<template>
  <CTabs variant="tabs" class="nav-tabs-boxed">
    <CTab title="Tipos de Contato">
      <crud-base
        :url="url"
        :columns="columns"
        :onDelete="() => {}"
        :onUpdate="() => {}"
        :onStore="() => {}"
        :enableSearch="true"
        :checkAlerts="true"
        :formInputs="formInputs"
        primaryKey="id"
      />
    </CTab>
  </CTabs>
</template>

<script>
import CrudBase from "../../components/crud/CrudBase";
import { schemaTextField, schemaBooleanSelect } from "@/helpers/form";
import { yesNoRepresentation } from "@/helpers/transformers";

export default {
  name: "TipoContato",
  components: {
    CrudBase,
  },
  data() {
    return {
      url: "/admin/tipo-contato",
      columns: [
        { label: "ID", field: "id", sortable: false },
        { label: "DESCRIÇÃO", field: "descricao", sortable: false },
        {
          label: "ATIVO",
          field: "ativo",
          sortable: false,
          representedAs: (row) => yesNoRepresentation(row.ativo),
        },
      ],
      formInputs: {
        id: schemaTextField("Cód.", true, 3),
        descricao: schemaTextField("Descrição", true, 7),
        ativo: schemaBooleanSelect("Ativo", true, 2, 1, 1),
      },
    };
  },
};
</script>
